import React, { useRef, useEffect } from 'react';
import './ContactUsModal.css';

const ContactUsModal = ({ currentLanguage, getLocalizedText, onClose }) => {
  const modalRef = useRef(null);

  const t = (ar, en) => getLocalizedText(ar, en);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (modalRef.current && !modalRef.current.contains(e.target)) {
        onClose();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleEsc);
    return () => document.removeEventListener('keydown', handleEsc);
  }, [onClose]);

  return (
    <div className="contactus-modal-overlay">
      <div className={`contactus-modal ${currentLanguage === 'ar' ? 'ar' : 'en'}`} ref={modalRef}>
        <button className="contactus-modal-close" onClick={onClose} aria-label="Close">×</button>

        <div className="contactus-modal-content">
          <h2 className="contactus-modal-title">
            {t('تواصل معنا', 'Contact Us')}
          </h2>

          <div className="contactus-info">
            <div className="contactus-row">
              <span className="contactus-label">
                {t('رقم الواتس: ', 'Whatsapp Number: ')}
              </span>
              <span className="contactus-value" dir="ltr">+201500743991</span>
            </div>

            <div className="contactus-row">
              <span className="contactus-label">
                {t('البريد الإلكتروني: ', 'Email: ')}
              </span>
              <span className="contactus-value" dir="ltr">roommateeg@gmail.com</span>
            </div>
          </div>

          <p className="contactus-note">
            {t('يمكنك التواصل معنا عبر الهاتف أو البريد الإلكتروني لأي استفسار أو مساعدة.', 
                'You can contact us via phone or email for any inquiries or assistance.')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ContactUsModal;